import React from "react";

import NavBar from "@landing-components/NavBar/NavBar";
import SEO from "@components/seo";
import Footer from "@landing-components/Footer/Footer";

import "./contact.scss";

const ContactPage = (props) => {
    return (
        <div className="contact-page text-block">
            <SEO type="corporation" metadata={{ title: "Scribe: Contact Us" }} />
            <NavBar theme="light" />

            <div className="page-content">
                <h1>Contact</h1>
                <p>
                    For general inquiries, help, or even just someone to talk to email me at{" "}
                    <a href="mailto: hello@scribe.wiki">hello@scribe.wiki</a>{" "}
                </p>
            </div>
            <Footer />
        </div>
    );
};

export default ContactPage;
